module.exports = __webpack_public_path__ + "static/img/7.7e3483f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/sp/7.png
// module id = GTBC
// module chunks = 0